import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-invite-focus-dialog',
    templateUrl: './invite-focus-dialog.component.html',
    styleUrl: './invite-focus-dialog.component.css',
    standalone: false
})
export class InviteFocusDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<InviteFocusDialogComponent>,
    public router: Router,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  closeTooltip() {
    this.dialogRef.close();
  }

  updatePosition(top: any, left: any, width: any, height: any) {
    this.data.top = top;
    this.data.left = left;
    this.data.width = width;
    this.data.height = height;
    this.cd.detectChanges();
  }

  goToHelpAndSupportPage() {
    this.dialogRef.close();
    this.router.navigate(['/help-support']);
  }
}
